import React from 'react';
import BaseModal, {
	BaseModalProps,
} from '../../../../Base/Components/BaseModal/BaseModal';
import MedicalRequestPoland from './MedicalRequestPoland';

interface Props extends BaseModalProps {
	patientId: string;
	onSuccess: (jobId: string) => void;
}

const MedicalRequestPolandModal: React.FC<Props> = props => {
	return (
		<BaseModal {...props} title='component.medicalRequestPolandModal.title'>
			<MedicalRequestPoland
				patientId={props.patientId}
				onSuccess={props.onSuccess}
			/>
		</BaseModal>
	);
};

export default MedicalRequestPolandModal;
